import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
import clsx from "clsx";
const useStyles = makeThemedStyles("SideBar", (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minWidth: "220px",
    gap: "20px",
    margin: "0px",
    padding: "10px",
  },
}));

const SideBar = (props: React.PropsWithChildren<{ className?: string }>) => {
  const styles = useStyles();
  return (
    <div className={clsx(styles.container, props.className || "")}>
      {props.children}
    </div>
  );
};

export default SideBar;
